<template>
  <div v-show="active">
    <UsersTable
      v-if="keepAlive"
      ref="sellerViewer"
      reference="sellerViewerTable"
      :namespace="`users?group_id=${groupSellerViewer}`"
      :groups="groups"
      @delete="$emit('delete', $event)"
      @edit="$emit('edit', $event)"
    />
  </div>
</template>

<script>
import UsersTable from "./UsersTable.vue";

export default {
  name: "SellerViewer",
  props: {
    groups: {
      type: Array,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    UsersTable,
  },
  data() {
    return {
      keepAlive: false,
    };
  },
  computed: {
    groupSellerViewer() {
      return this.groups.find((group) => group.name === "Seller-Viewer")?.id;
    },
  },
  watch: {
    active(newValue) {
      if (newValue && !this.keepAlive) {
        this.keepAlive = true;
      }
    },
  },
  methods: {
    loadData() {
      this.$refs.sellerViewer?.getData();
    },
  },
};
</script>
